import { Color, Text } from 'zens-storybook'
import React from 'react'
import { StyleSheet, View } from 'react-native'
import { Product, useBuildings, useFloors } from 'zens-store'

const styles = StyleSheet.create({
  detail: {
    color: Color.metalGrey,
    fontSize: 14,
  },
})

interface Props {
  companyId: number
  product: Product
}
const ProductLocation = (props: Props) => {
  const { companyId, product } = props
  const { floorId } = product
  const floor = useFloors({
    companyId,
  }).data?.find((floor) => floor.id === floorId)
  const building = useBuildings({
    companyId,
  }).data?.find((building) => building.id === floor?.buildingId)
  return (
    <View>
      <Text>{floor?.displayName}</Text>
      <Text style={styles.detail}>{building?.name}</Text>
    </View>
  )
}

export default ProductLocation
